import "../assets/css/about.css";
import React, { useEffect } from "react";
import {
  animation,
  headerSet,
  showNavLink,
  skillProgressAnimation,
} from "../Helper/CssHelper";
import CountUp from "react-countup";
import { Waypoint } from "react-waypoint";
// import AboutMeData from "../data/AboutMeData";

function AboutMe(props) {
  const AboutMeData = props.AboutMeData;
  // console.log(AboutMeData);

  useEffect(() => {
    headerSet("About-Me | Justin Dsouza");
    showNavLink("aboutme", "about-section");
    animation("about-section");
  }, []);

  return (
    <section id="about-section" className="about section-show">
      {/* <!-- ======= About Me  ======= --> */}
      <div className="about-me container">
        <div className="section-title">
          <h2>About</h2>
          <p>Learn about me</p>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-4 my-auto mx-auto" data-aos="fade-right">
            {AboutMeData.imagebaseurl && (
              <img
                src={AboutMeData.imagebaseurl}
                className="img-fluid rounded mx-auto d-block"
                style={{ maxWidth: "70%" }}
                alt=""
              />
            )}
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
            {AboutMeData.role && <h3>{AboutMeData.role}</h3>}
            {AboutMeData.shortDescription && (
              <p className="fst-italic">{AboutMeData.shortDescription}</p>
            )}
            <div className="row">
              <div className="col-lg-6">
                <ul>
                  {AboutMeData.InfoLeft &&
                    AboutMeData.InfoLeft.map((point, index) => {
                      return (
                        <li key={index}>
                          <i className="bi bi-chevron-right"></i>{" "}
                          <strong>{point.field}:</strong>{" "}
                          <span>{point.value}</span>
                        </li>
                      );
                    })}
                </ul>
              </div>
              <div className="col-lg-6">
                <ul>
                  {AboutMeData.InfoRight &&
                    AboutMeData.InfoRight.map((point, index) => {
                      return (
                        <li key={index}>
                          <i className="bi bi-chevron-right"></i>{" "}
                          <strong>{point.field}:</strong>{" "}
                          <span>{point.value}</span>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
            {AboutMeData.largeDescription && (
              <p>{AboutMeData.largeDescription}</p>
            )}
          </div>
        </div>
      </div>
      {/* <!-- End About Me --> */}

      {/* <!-- ======= Counts ======= --> */}
      <div className="counts container pt-0 d-none d-md-block">
        <div className="row d-flex justify-content-center">
          {AboutMeData.countUp &&
            AboutMeData.countUp.map((item, index) => {
              return (
                <div className="col-lg-3 col-md-6 mt-5" key={index}>
                  <div className="count-box">
                    <i className={item.icon}></i>
                    <CountUp
                      start={0}
                      end={item.countTill}
                      duration={2}
                      delay={0}
                      redraw={true}
                    >
                      {({ countUpRef }) => (
                        <div>
                          <span ref={countUpRef} />
                        </div>
                      )}
                    </CountUp>
                    <p>{item.counterFor}</p>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {/* <!-- End Counts --> */}

      {/* <!-- ======= Skills  ======= --> */}
      <Waypoint onEnter={skillProgressAnimation} bottomOffset={"10%"}>
        <div className="skills container">
          <div className="section-title">
            <h2 className="mb-0">Skills</h2>
          </div>
          <div className="row skills-content d-flex justify-content-center">
            {AboutMeData.skills &&
              AboutMeData.skills.map((item, index) => {
                return (
                  <div className="col-lg-6 mt-4" key={index}>
                    <h2>{item.name}</h2>
                    {item.bars.map((bars, index) => {
                      return (
                        <div className="progress" key={index}>
                          <span className="skill">
                            {bars.name} <i className="val">{bars.progress}%</i>
                          </span>
                          <div className="progress-bar-wrap">
                            <div
                              className="progress-bar"
                              role="progressbar"
                              aria-valuenow={bars.progress}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        </div>
      </Waypoint>

      {/* <!-- End Skills --> */}

      {/* <!-- ======= Interests ======= --> */}
      <div className="interests container d-none d-md-block">
        <div className="section-title">
          <h2 className="mb-0">Interests</h2>
        </div>
        <div className="row">
          {AboutMeData.intrests &&
            AboutMeData.intrests.map((item, index) => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 mt-4" key={index}>
                  <div className="icon-box">
                    <i className={item.logo} style={{ color: item.color }}></i>
                    <h3>{item.name}</h3>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {/* <!-- End Interests --> */}
    </section>
  );
}

export default AboutMe;
